import React, {useState} from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import ErrorIcon from '../Assets/SVG/errorIcon';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';
import {isMobile} from 'react-device-detect';

const GeneralErrorScreen = (props) => {
  const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;

  const mobileCall = (
    <BtnSubmit
      className='btn-submit-white TipCallBtn'
      isDisplayWhatsAppIcon={false}
      onclick={() => {
        window.location.href = 'tel:*'+ window.Config.technicalSupportPhone;
      }}
      text='לשיחה עם נציג'
    />
  );
  const desktopCall = <div className='TipCall'>או חייגו {window.Config.technicalSupportPhone} לנציג שירות</div>;
  return (
    <div className='screenContainer'>
      <ErrorIcon />
      <h3 className='heading withSecondary'>אופס.. משהו השתבש</h3>
      <h4 className='secondaryHeading'>
        מצטערים, משהו השתבש בתהליך ולא ניתן לבצע את הפעולה שביקשת, באפשרותך לנסות שוב או לפנות לנציגים שלנו בצ'אט <br />
        או בטלפון
      </h4>

      {isMobile ? mobileCall : desktopCall}
      {props.isFull && (
        <Footer
          text={'לעמוד הבית'}
          onclick={() => {
            window.location.href = Config.staticWebSiteUrl;
          }}
        />
      )}
    </div>
  );
};

export default GeneralErrorScreen;
